import { Controller } from "@hotwired/stimulus";
import { FrameElement } from "@hotwired/turbo";

/**
 * Force a turbo-frame to be refreshed by settings its src to itself after a delay
 * Usage example:
 *
 * To trigger the refresh, add an element like the following one to a turbo-frame:
 * ```html
 *   <div data-controller="turbo-refresh" data-turbo-refresh-delay-seconds-value="0"></div>
 * ```
 * This can be added using streams.
 */
export default class extends Controller {
  static values = { delaySeconds: Number };
  declare delaySecondsValue: number;
  private timer?: ReturnType<typeof setTimeout>;

  disconnect(): void {
    if (this.timer !== undefined) clearTimeout(this.timer);
  }

  connect(): void {
    const turboFrame = this.element.closest("turbo-frame") as FrameElement;
    if (!turboFrame?.src) return;
    this.timer = setTimeout(() => {
      if (this.element.isConnected) turboFrame.reload();
    }, this.delaySecondsValue * 1000);
  }
}
